export default __webpack_public_path__ + "assets/home-two-three.9d62e0a74ab8bb6ce7f891eecc35d9cc.png";